// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1768":"3bc905bb0d99656c","5750":"fb32215b27e5586e"}[chunkId] + ".css";
};